const formaPagamento = (DataBase, Datatype) => {
	const FormaPagamento = DataBase.new(
		{
			nome: Datatype.STRING,
		},
		{
			tracked: true,
			dateLogs: true,
			softDelete: true,
			collection: "forma_pagamento",
			model: "FormaPagamento",
		}
	);

	return FormaPagamento;
};

export default formaPagamento;
